import { render, staticRenderFns } from "./time-proportion.vue?vue&type=template&id=d5ef9e64&"
import script from "./time-proportion.vue?vue&type=script&lang=js&"
export * from "./time-proportion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports